/// <amd-module name="Search/WorkItem/Components/RightPane/RightPane" />
import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { TimeoutComponent } from "Search/Shared/Components/TimeoutComponent";
import { PreviewNotificationContainer } from "Search/WorkItem/Components/RightPane/PreviewNotificationContainer";
import * as Constants from "Search/WorkItem/Constants";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { WorkitemPreviewPaneScenario } from "Search/WorkItem/Flux/Stores/PreviewNotificationStore";
import { IAggregatedState, StoreName, StoresHub } from "Search/WorkItem/Flux/StoresHub";
import { getFieldValue } from "Search/WorkItem/Utils";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { isFeatureEnabled } from "VSS/Platform/Feature";
import { WrappedComponent } from "VSS/Platform/Layout";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export const RightPaneContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    [
        "itemContentStore"
    ],
    ({
        selectedItem
    }, props) => {
        const selectedItemId = selectedItem ? getFieldValue(selectedItem.fields, "system.id") : undefined;
        const selectedItemRev = selectedItem ? getFieldValue(selectedItem.fields, "system.rev") : undefined;
        const {
            showBanner,
            onPreviewLoaded,
            onPreviewLoadFailed,
            dismissBanner
        } = props.actionCreator;

        const onLoad = (workItem?: IWorkItem) => {
            if (!workItem) {
                showBanner(WorkitemPreviewPaneScenario.Deleted);
                onPreviewLoadFailed();
                return;
            }
        
            if (selectedItemRev) {
                if (workItem.revision.value > parseInt(selectedItemRev)) {
                    showBanner(WorkitemPreviewPaneScenario.Stale);
                } else {
                    dismissBanner();
                }
            }
        
            onPreviewLoaded();
        };

        const newBoardsHubs = isFeatureEnabled(props.pageContext, Constants.FeatureConstants.NewBoardsHubs, false);
        const parsedWorkItemId = parseInt(selectedItemId ?? "");
        return (
            <div className="work-item-preview-container flex-column flex-grow relative scroll-hidden">
                <PreviewNotificationContainer {...props} />
                {!isNaN(parsedWorkItemId) && 
                    <TimeoutComponent timeout={0}>
                        {newBoardsHubs ? 
                            <WrappedComponent
                                dependencies={["ms.vss-work-web.work-item-form-dependencies"]}
                                wrappedType="work-item-form-view-component"
                                workItemId={parsedWorkItemId}
                                className="flex-column flex-grow scroll-hidden"
                                onLoad={onLoad}
                            /> :
                            <LegacyComponent
                                modules={["Search/Scenarios/WorkItem/Components/WorkItemPreview"]}
                                wrappedType="search.workitem.preview"
                                wrappedProps={{
                                    workItemId: selectedItemId,
                                    workItemRev: selectedItemRev,
                                    className: "flex-grow",
                                    rootClassName: "flex-column flex-grow scroll-hidden",
                                    onShowBanner: showBanner,
                                    onSuccess: onPreviewLoaded,
                                    onError: onPreviewLoadFailed,
                                    onDismissBanner: dismissBanner
                                }} /> 
                        }
                    </TimeoutComponent>
                }
            </div>
        );
    });
